module.exports = __webpack_public_path__ + "static/img/map1.a099d2f6.png";